import { BannerId } from '../../typings/banners';
import { Measurers } from '../../typings/bannersEditState';
import { EditorPlaceId, ValidationErrorData } from '../../typings/common';
import { RejectReasonsData } from '../../typings/domain';
import { GdBannerMeasurerSystem } from '../../typings/graphql-grid';

export const CHANGE_PIXEL_VALUE = 'CHANGE_PIXEL_VALUE';
export type CHANGE_PIXEL_VALUE = typeof CHANGE_PIXEL_VALUE;
export interface ChangePixelValueAction {
    type: CHANGE_PIXEL_VALUE;
    bannerId: EditorPlaceId;
    value: string;
    errors?: ValidationErrorData[];
}
export function changePixelValue(
    bannerId: BannerId,
    value: string,
    errors?: ValidationErrorData[]
): ChangePixelValueAction {
    return {
        type: CHANGE_PIXEL_VALUE,
        bannerId,
        value,
        errors
    };
}

export const CHANGE_SHOWS_COUNTERS_VALUE = 'CHANGE_SHOWS_COUNTERS_VALUE';
export type CHANGE_SHOWS_COUNTERS_VALUE = typeof CHANGE_SHOWS_COUNTERS_VALUE;
export interface ChangeShowsCountersValueAction {
    type: CHANGE_SHOWS_COUNTERS_VALUE;
    bannerId: EditorPlaceId;
    value: string;
    index: number;
    errors?: ValidationErrorData[];
}
export function changeShowsCountersValue(
    bannerId: BannerId,
    value: string,
    index: number,
    errors?: ValidationErrorData[]
): ChangeShowsCountersValueAction {
    return {
        type: CHANGE_SHOWS_COUNTERS_VALUE,
        bannerId,
        value,
        index,
        errors
    };
}

export const REMOVE_SHOWS_COUNTERS_ROW = 'REMOVE_SHOWS_COUNTERS_ROW';
export type REMOVE_SHOWS_COUNTERS_ROW = typeof REMOVE_SHOWS_COUNTERS_ROW;
export interface RemoveShowsCountersRowAction {
    type: REMOVE_SHOWS_COUNTERS_ROW;
    bannerId: EditorPlaceId;
    index: number;
    errors?: ValidationErrorData[];
}
export function removeShowsCountersRow(
    bannerId: BannerId,
    index: number,
    errors?: ValidationErrorData[]
): RemoveShowsCountersRowAction {
    return {
        type: REMOVE_SHOWS_COUNTERS_ROW,
        bannerId,
        index,
        errors
    };
}

export const ADD_SHOWS_COUNTERS_ROW = 'ADD_SHOWS_COUNTERS_ROW';
export type ADD_SHOWS_COUNTERS_ROW = typeof ADD_SHOWS_COUNTERS_ROW;
export interface AddShowsCountersRowAction {
    type: ADD_SHOWS_COUNTERS_ROW;
    bannerId: EditorPlaceId;
}
export function addShowsCountersRow(bannerId: BannerId): AddShowsCountersRowAction {
    return {
        type: ADD_SHOWS_COUNTERS_ROW,
        bannerId
    };
}

export const CHANGE_MEASURER_VALUE = 'CHANGE_MEASURER_VALUE';
export type CHANGE_MEASURER_VALUE = typeof CHANGE_MEASURER_VALUE;
export interface ChangeMeasurerValue {
    type: CHANGE_MEASURER_VALUE;
    bannerId: BannerId;
    value: Measurers;
}
export function changeMeasurerValue(bannerId: BannerId, value: Measurers): ChangeMeasurerValue {
    return {
        type: CHANGE_MEASURER_VALUE,
        bannerId,
        value
    };
}

export const ADD_MEASURER_VALUE = 'ADD_MEASURER_VALUE';
export type ADD_MEASURER_VALUE = typeof ADD_MEASURER_VALUE;
export interface AddMeasurerValue {
    type: ADD_MEASURER_VALUE;
    bannerId: BannerId;
    value: GdBannerMeasurerSystem;
}

export function addMeasurerValue(bannerId: BannerId, value: GdBannerMeasurerSystem): AddMeasurerValue {
    return {
        type: ADD_MEASURER_VALUE,
        bannerId,
        value
    };
}

export const DELETE_MEASURER = 'DELETE_MEASURER';
export type DELETE_MEASURER = typeof DELETE_MEASURER;
export interface DeleteMeasurer {
    type: DELETE_MEASURER;
    bannerId: BannerId;
    value: GdBannerMeasurerSystem;
}

export function deleteMeasurer(bannerId: BannerId, value: GdBannerMeasurerSystem): DeleteMeasurer {
    return {
        type: DELETE_MEASURER,
        bannerId,
        value
    };
}

export const GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS = 'GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS';
export type GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS = typeof GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS;

export interface GetBannnerForEditModerationRejectReasons {
    type: GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS;
    bid: string;
}

export function getBannerForEditModerationRejectReasons(bid: string): GetBannnerForEditModerationRejectReasons {
    return {
        type: GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS,
        bid
    };
}

export const UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS = 'UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS';
export type UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS = typeof UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS;

export interface UpdateBannerForEditModerationRejectReasons {
    type: UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS;
    bid: string;
    reasons: RejectReasonsData;
}

export function updateBannerForEditModerationRejectReasons(
    bid: string,
    reasons: RejectReasonsData
): UpdateBannerForEditModerationRejectReasons {
    return {
        type: UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS,
        bid,
        reasons
    };
}

export const SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR =
    'SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR';
export type SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR = typeof SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR;

export interface SetBannerForEditModerationRejectReasonsError {
    type: SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR;
    error: string;
    bid: string;
}

export function setBannerForEditModerationRejectReasonsError(
    bid: string,
    error: string
): SetBannerForEditModerationRejectReasonsError {
    return {
        type: SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR,
        bid,
        error
    };
}

export const CHANGE_TNS_ID_VALUE = 'CHANGE_TNS_ID_VALUE';
export type CHANGE_TNS_ID_VALUE = typeof CHANGE_TNS_ID_VALUE;
export interface ChangeTnsIdValueAction {
    type: CHANGE_TNS_ID_VALUE;
    bannerId: BannerId;
    value: string;
}

export function changeTnsIdValueAction(bannerId: BannerId, value: string): ChangeTnsIdValueAction {
    return {
        type: CHANGE_TNS_ID_VALUE,
        bannerId,
        value
    };
}

export type CpmBannerActions =
    | ChangeShowsCountersValueAction
    | RemoveShowsCountersRowAction
    | AddShowsCountersRowAction
    | ChangePixelValueAction
    | GetBannnerForEditModerationRejectReasons
    | UpdateBannerForEditModerationRejectReasons
    | SetBannerForEditModerationRejectReasonsError
    | ChangeMeasurerValue
    | AddMeasurerValue
    | DeleteMeasurer
    | ChangeTnsIdValueAction;
